<!-- <ion-item button (click)="changeDatetime()">
    <ion-label position="stacked">{{ 'Start date' | translate }}</ion-label>
    <ion-text>{{ date | date: 'MMMM d, y, h:mm a' }}</ion-text>
</ion-item> -->

<ion-item>
    <ion-label>{{ 'Start date' | translate }}</ion-label>
    <ion-datetime-button slot="end" datetime="schedulepopover"></ion-datetime-button>
</ion-item>

<ion-popover [keepContentsMounted]="true" >
    <ng-template>
        <ion-datetime
            #schedulepopover
            presentation="date-time"
            id="schedulepopover"
            [preferWheel]="true"
            [showDefaultButtons]="true"
            (ionChange)="changeDatetime($event)">
        </ion-datetime>
    </ng-template>
</ion-popover>